export default {
  className: 'activityRecord',
  mixin: {
    perPage: 10,
    fields: [
      {
        name: 'user',
        note: '参与用户',
        width: 170
      },
      {
        name: 'createdAt',
        note: '参与时间'
      }
    ],
    action: {
      create: false,
      edit: false,
      delete: false
    }
  }
}
